// extracted by mini-css-extract-plugin
export default {"wrapper":"ColorBar_wrapper__JGRJS","barWrapper":"ColorBar_barWrapper__UCY4h"};